export const measures = [
  {
    id: "m1",
    name: "Wärmepumpe",
    beschreibung: "",
    scope: "Scope 1",
    einsparung_pro_jahr: 65.2, // tCO2/Jahr
    relative_kosteneinsparung: 70, // Prozent
    Kostenstelle: "Heizungskosten",
    anteil_gesamtkosten: 30.63, // Prozent
    investitionsbedarf: 70000, // CHF
    relativ_investition: 142.91, //Prozent
    amortisationszeit: 6.7, // Jahre
    buildingRelated: true,
  },
  {
    id: "m2",
    name: "Elektrofahrzeuge kaufen",
    beschreibung: "",
    scope: "Scope 1",
    einsparung_pro_jahr: 5.5, // tCO2/Jahr
    relative_kosteneinsparung: 53, // Prozent
    Kostenstelle: "Treibstoffkosten",
    anteil_gesamtkosten: 7.23, // Prozent
    investitionsbedarf: 30000, // CHF
    relativ_investition: 61.25, //Prozent
    amortisationszeit: 15.9, // Jahre
  },
  {
    id: "m3",
    name: "Lackierkabine ersetzen",
    beschreibung: "",
    info: "Fördergelder: Colorwatt bis Juni 2027",
    scope: "Scope 1",
    einsparung_pro_jahr: 36.7, // tCO2/Jahr
    relative_kosteneinsparung: 54, // Prozent
    Kostenstelle: "Heiz- und Stromkosten",
    anteil_gesamtkosten: 57.94, // Prozent
    investitionsbedarf: 120000, // CHF
    relativ_investition: 244.98, //Prozent
    amortisationszeit: 7.8, // Jahre
  },
  {
    id: "m4",
    name: "Reparaturquote erhöhen",
    beschreibung: "",
    scope: "Scope 3",
    einsparung_pro_jahr: 8.4, // tCO2/Jahr
    relative_kosteneinsparung: 8, // Prozent
    Kostenstelle: "Einkauf Ersatzteile",
    anteil_gesamtkosten: 0, // Prozent
    investitionsbedarf: 15000, // CHF
    relativ_investition: 0, //Prozent
    amortisationszeit: 0.3, // Jahre
  },
  {
    id: "m5",
    name: "LED-Installation",
    beschreibung: "",
    scope: "Scope 2",
    einsparung_pro_jahr: 0.4, // tCO2/Jahr
    relative_kosteneinsparung: 14, // Prozent
    Kostenstelle: "Stromkosten",
    anteil_gesamtkosten: 4.2, // Prozent
    investitionsbedarf: 15000, // CHF
    relativ_investition: 30.62, //Prozent
    amortisationszeit: 51.1, // Jahre
    buildingRelated: true,
  },
];
